import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import MerchantBadge from 'domains/merchant/atoms/merchant-badge'
import PhotographyStatusBadge from 'domains/merchant-product/atoms/photography-status-badge'
import PhotoEditedStatusBadge from 'domains/merchant-product/atoms/photo-edited-status-badge'
import PhotoUploadStatusBadge from 'domains/merchant-product/atoms/photo-upload-status-badge'
import PhotoCurationStatusBadge from 'domains/merchant-product/atoms/photo-curation-status-badge'
import LiveProcessStatusBadge from 'domains/merchant-product/atoms/live-process-status-badge'
import { MERCHANT_TYPE } from 'domains/merchant/constants'
import {
  PHOTOGRAPHY_STATUS,
  PHOTO_EDITED_STATUS,
  PHOTO_UPLOAD_STATUS,
  LIVE_PROCESS_STATUS
} from 'domains/merchant-product/constants'
import React from 'react'
import TimeUtil from 'utils/time-util'

/**
 * Merchant Product Table Columns
 */
const merchantProductTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick,
  isButtonDisabled
}) => {
  // eslint-disable-next-line react/prop-types
  const MerchantTypeFilter = ({ column }) => {
    const options = Object.keys(MERCHANT_TYPE).map((key) => (
      {
        label : MERCHANT_TYPE[key],
        value : MERCHANT_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const PhotographyStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTOGRAPHY_STATUS).map((key) => (
      {
        label : PHOTOGRAPHY_STATUS[key],
        value : PHOTOGRAPHY_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const PhotoEditedStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_EDITED_STATUS).map((key) => (
      {
        label : PHOTO_EDITED_STATUS[key],
        value : PHOTO_EDITED_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const PhotoUploadStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_UPLOAD_STATUS).map((key) => (
      {
        label : PHOTO_UPLOAD_STATUS[key],
        value : PHOTO_UPLOAD_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const LiveProcessStatusFilter = ({ column }) => {
    const options = Object.keys(LIVE_PROCESS_STATUS).map((key) => (
      {
        label : LIVE_PROCESS_STATUS[key],
        value : LIVE_PROCESS_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const MerchantTypeCell        = (row) => <MerchantBadge merchant_type={ row.cell.value } />
  const PhotographyStatusCell   = (row) => <PhotographyStatusBadge photographyStatus={ row.cell.value } />
  const PhotoEditedStatusCell   = (row) => <PhotoEditedStatusBadge photoEditedStatus={ row.cell.value } />
  const PhotoUploadStatusCell   = (row) => <PhotoUploadStatusBadge photoUploadStatus={ row.cell.value } />
  const PhotoCurationStatusCell = (row) => <PhotoCurationStatusBadge photoCurationStatus={ row.cell.value } />
  const LiveProcessStatusCell   = (row) => <LiveProcessStatusBadge liveProcessStatus={ row.cell.value } />
  const DateCell                = (row) => TimeUtil.format(row.cell.value)

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {
    // eslint-disable-next-line react/prop-types
    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        // eslint-disable-next-line react/prop-types
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        disabled={ disabled }
        text={ buttonText }
      />
    )
  }

  return (
    [
      {
        Header  : 'Merchant',
        columns : [
          {
            Header   : 'Merchant Name',
            id       : 'merchant_name',
            accessor : 'merchant.name'
          },
          {
            Header   : <>Merchant <br/> Code</>,
            id       : 'merchant_code',
            accessor : 'merchant.code'
          },
          {
            Header   : <>Merchant <br/> Type</>,
            accessor : 'merchant.merchant_type',
            id       : 'merchant_type',
            Filter   : MerchantTypeFilter,
            Cell     : MerchantTypeCell
          },
          {
            Header   : <>Merchant <br/>Phone</>,
            id       : 'merchant_phone',
            accessor : 'merchant.phone_number'
          }
        ]
      },
      {
        Header  : 'Merchant Product',
        columns : [
          {
            Header         : 'Id',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header   : 'SKU',
            accessor : 'sku'
          },
          {
            Header   : <>Merchant<br/>SKU</>,
            accessor : 'merchant_sku'
          },
          {
            Header         : 'Name',
            accessor       : 'name',
            disableFilters : true
          },
          {
            Header         : 'Category',
            accessor       : 'category',
            disableFilters : true
          },
          {
            Header   : <>Photography <br/> Status</>,
            accessor : 'photography_status',
            Filter   : PhotographyStatusFilter,
            Cell     : PhotographyStatusCell
          },
          {
            Header   : <>Photo Edit<br/> Status</>,
            accessor : 'photo_edited_status',
            Filter   : PhotoEditedStatusFilter,
            Cell     : PhotoEditedStatusCell
          },
          {
            Header   : <>Photo Upload<br/> Status</>,
            accessor : 'photo_upload_status',
            Filter   : PhotoUploadStatusFilter,
            Cell     : PhotoUploadStatusCell
          },
          {
            Header         : <>Photo Curation<br/> Status</>,
            accessor       : 'photo_curation_status',
            disableFilters : true,
            Cell           : PhotoCurationStatusCell
          },
          {
            Header         : <>Photo Curation<br/> Date</>,
            accessor       : 'photo_curation_date',
            disableFilters : true,
            Cell           : DateCell
          },
          {
            Header   : <>Live Process<br/> Status</>,
            accessor : 'live_process_status',
            Filter   : LiveProcessStatusFilter,
            Cell     : LiveProcessStatusCell
          },
          {
            Header         : <>Live<br/>Date</>,
            accessor       : 'live_date',
            disableFilters : true,
            Cell           : DateCell
          }
        ]
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default merchantProductTableColumns
